
import { useEffect } from 'react';
import { useSignalR } from '../context/SignalRContext';

export const useSignalREvent = (eventKey: string, pageKey: string, callback: (data?: any) => void) => {
    const { subscribeToEvent, unsubscribeFromEvent } = useSignalR();

    useEffect(() => {
        if (!eventKey || !pageKey) return;

        subscribeToEvent(eventKey, pageKey, callback);

        return () => {
            unsubscribeFromEvent(eventKey, pageKey);
        };
    }, [eventKey, pageKey, callback, subscribeToEvent, unsubscribeFromEvent]);
};
